<template>
    <div v-cloak>


        <el-steps :active="2" align-center>
            <el-step title="选择模板" description="请选择需要的操作">
            </el-step>
            <el-step title="上传文件" description="请上传excel、csv文件">

            </el-step>
            <el-step title="校验数据" description="请核对需要导入的数据">

            </el-step>
            <el-step title="查看结果" description="请查看结果和处理错误数据">

            </el-step>
        </el-steps>
        <div class="main">

            <el-row>
                <div style="min-height:200px;max-height:600px;margin-top:5px;overflow: auto;">
                    <table class="ImportExcelTable">
                        <thead>
                        <tr>
                            <th style="min-width: 40px;width:40px">序号</th>
                            <th v-for="(p,index) in ImportConfig" v-bind:key="index">{{p.name}}</th>
                            <th style="min-width: 80px;max-width: 80px;width:80px">处理状态</th>
                            <th style="min-width: 120px;max-width: 200px;width:160px">错误信息</th>
                            <th v-if="editFlag" style="min-width: 40px;max-width: 40px;width:40px">操作</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(item,index) in items" v-bind:key="index" v-if='index<limit'>
                            <td style="min-width: 40px;width:40px;text-align: center;">
                                <span>{{index+1}}</span>
                            </td>
                            <td v-for="(p,index) in ImportConfig" v-bind:key="index">

                                <span v-if="!editFlag">{{item[p.field]}}</span>
                                <el-input size="mini" v-if="editFlag" v-model="item[p.field]"
                                          placeholder=""></el-input>
                            </td>
                            <td style="min-width: 80px;max-width: 80px;width:80px;text-align: center;">
                                <span>{{item.import_status}}</span>
                            </td>
                            <td style="min-width: 120px;max-width: 200px;width:160px;text-align: center;color: #ff2238">
                                <span>{{item.import_message}}</span>
                            </td>
                            <td v-if="editFlag"
                                style="min-width: 120px;max-width: 200px;width:120px;text-align: center;">
                                <span style="cursor: pointer;color: #409EFF;" @click="deleteId(index)">删除</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <div class="grid-content totalInfo">
                        <span>总记录数:<span style="font-size: 18px">{{totalCount}}</span>条,</span>
                        <span v-if="totalCount>200">当前显示:<span style="font-size: 18px">{{limit}}/{{totalCount}}</span>,<el-button type="text" @click="limit=totalCount">全部展示</el-button></span>
                        <span>当前状态:<span style="color: #00ee00;font-size: 18px">{{currentStatus}},</span></span>
                        <span v-if="currentCount>0 && currentCount<totalCount">正在处理第:{{currentCount}}条,</span>
                        <span>成功:<span style="color: #00ee00;font-size: 18px">{{successCount}}</span>条,</span>
                        <span>失败:{{errorCount}}条,</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">

                        <el-progress v-if="errorCount==0" :text-inside="true" :stroke-width="18"
                                     :percentage="Math.ceil(currentCount * 100/totalCount)" status="success"></el-progress>
                        <el-progress v-if="errorCount!=0" :text-inside="true" :stroke-width="18"
                                     :percentage="Math.ceil(currentCount * 100/totalCount)" status="exception"></el-progress>
                    </div>
                </el-col>

                <el-col :span="4">
                    <div class="grid-content"></div>
                </el-col>


            </el-row>
            <el-row class="button">
                <el-button type="primary" size="mini" @click="laststep()" v-if="!importDialog">上一步</el-button>
                <el-button v-if="editFlag==false" type="primary" size="mini" @click="editFlag=true,limit=totalCount">编辑</el-button>
                <el-button v-if="editFlag==true" type="primary" size="mini" @click="saveEdit()">保存编辑</el-button>
                <el-button type="primary" size="mini" @click="doCheck()">校验数据</el-button>
                <el-button type="primary" :disabled="totalCount>0 && totalCount!=successCount" size="mini"
                           @click="doImport()">开始导入
                </el-button>
                <el-button type="primary" size="mini" @click="nextstep()" v-if="!importDialog">查看已导入数据</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
  import DataStore from './data.store'

    var ImportConfig = []; // 存储导入配置变量
    var requirdConfig = []; // 存放必输的字段
    var keyConfig = []; // 存放主键的字段
    var mvgConfig = []; // 存放mvg映射名称、存放mvg的目标字段，用于筛选、存放mvgfilter
    var lovMap = new Map(); // 存放值列表字段和类型
    var defaultValueMap = new Map(); // 存放默认值字段和默认值
    var coverValueMap = new Map(); // 存放覆盖值字段和覆盖值
    var redexValueMap = new Map(); // 存放正则表达式字段和正则值
    var pickValueMap = new Map(); // 存放正则表达式字段和url以及查询条件
    var mvgValueMap = new Map(); // 存放mvg字段和相关配置
    var requirdMsg = ''; // 存放必输字段的值
    var mvgMapperName = ''; // mvg映射名称
    var insertJson = []; // 用于mvg插入
    var dataLists = []; // 用于存储插入的数据
    var temConfig = '';   //用于存储excell的field
    export default {
        name: 'step3',
        props: {
            importDialog: {type: Boolean, default: false},
          	context: Object
        },
        data: function () {
            return {
                ImportConfig: ImportConfig,
                items: [], // 数据对象
                totalCount: 1, // 总记录数
                currentCount: 0, // 当前正在处理的记录数
                currentStatus: '未开始', // 当前状态
                errorCount: 0, // 错误记录数
                successCount: 0, // 成功记录数
                checkSuccesCount: 0, // 校验成功的记录数
                editFlag: false, // 编辑标记
                num: 0, // 计数器
                nums: 0, // pick校验数据辅助参数
                mvgNum: 0, // mvg校验数据辅助参数
                limit: 200 // 页面默认展示最多200条
            };
        },
        mounted() {
            if (DataStore.tmpPublicImportData && DataStore.tmpPublicImportData.length) {
                this.totalCount = DataStore.tmpPublicImportData.length; // 获取总记录数，以便显示在界面上
            } else {
                this.totalCount = 1; // 获取总记录数，以便显示在界面上
            }/**/
            this.initializedPubdataImportconfig()
            this.formatData(); // 格式化数据，把python服务从excell获取到数据从String格式转换成对象并push到数组中
        },
        watch: {}, // 监控变量变动
        methods: {

            /**
             * 把通过python服务获取到excell数据的json字符串拆分成对象push到items数组里面
             */
            formatData: function () {
                for (var k = 0; k < DataStore.tmpPublicImportData.length; k++) {
                    var tmp = {};
                    for (var i = 0; i < ImportConfig.length; i++) {
                        var title = ImportConfig[i].name;
                        var field = ImportConfig[i].field;
                        // 其实是一个映射
                        var value = DataStore.tmpPublicImportData[k][title];
                        if (value == undefined) {
                            tmp[field] = '';
                        } else {
                            tmp[field] = value;
                        }
                    }
                    // 将格式化后的数据对象push到数组里
                    this.items.push(tmp);
                }
            },

            initializedPubdataImportconfig() {
                if (DataStore.pubdataImportconfig) {
                    // 把不需要导入的字段过滤掉
                    temConfig = DataStore.pubdataImportconfig.field;
                    for (var i = 0; i < temConfig.length; i++) {
                        var pickConfig = []; // 存放pickList的url和查询条件
                        if (temConfig[i].importFlag === 'Y' && temConfig[i].field) {
                            ImportConfig.push(temConfig[i]);
                            // 把必输字段先存起来，以供数据校验用
                            if (temConfig[i].isRequired === 'Y' && temConfig[i].field) {
                                requirdConfig.push(temConfig[i].field);
                                requirdMsg = requirdMsg + temConfig[i].name + ' ';
                            }
                            // 把主键字段先存起来，来判断新增还是更新
                            if (temConfig[i].isKey === 'Y' && temConfig[i].field) {
                                keyConfig.push(temConfig[i].field);
                            }
                            // 把值列表字段和类型存起来，以供数据校验用
                            if (temConfig[i].lov && temConfig[i].field) {
                                lovMap.set(temConfig[i].field, temConfig[i].lov);
                            }
                            // 把有覆盖值的字段存储起来，校验数据时候用
                            if (temConfig[i].coverValue && temConfig[i].field) {
                                coverValueMap.set(temConfig[i].field, temConfig[i].coverValue);
                            }
                            // 把有默认值的字段存储起来，校验数据时候用
                            if (temConfig[i].defaultValue && temConfig[i].field) {
                                defaultValueMap.set(temConfig[i].field, temConfig[i].defaultValue);
                            }
                            // 把有正则校验的字段存储起来，校验数据时候用
                            if (temConfig[i].redex && temConfig[i].field) {
                                redexValueMap.set(temConfig[i].field, temConfig[i].redex);
                            }
                            // 把有picklist的字段存储起来，包括查询条件，以及目标对象等
                            if (temConfig[i].pickurl && temConfig[i].field) {
                                pickConfig.push(temConfig[i].pickurl); // picklist的查询url
                                pickConfig.push(temConfig[i].picksearch); // value[1]是查询条件
                                pickConfig.push(temConfig[i].targetProp); // value[2]是目标对象
                                var cacheMap = new Map();
                                pickConfig.push(cacheMap); // 缓存picklist查询的数据
                                var cacheNotFindMap = new Map();
                                pickConfig.push(cacheNotFindMap); // 记录picklist未查到键和标记
                                pickValueMap.set(temConfig[i].field, pickConfig);
                                pickConfig = []; // 每次set进map需要重新初始化
                            }
                            // 把有mvg的字段存储起来，包括查询条件，以及目标对象等
                            if (temConfig[i].mvgMapperName && temConfig[i].field) {
                                mvgMapperName = temConfig[i].mvgMapperName;
                                mvgConfig.push(temConfig[i].mvgMapperName);
                                mvgConfig.push(temConfig[i].mvgTarget);
                                mvgConfig.push(temConfig[i].mvgsearch);
                                var cacheMap = new Map();
                                pickConfig.push(cacheMap); // 缓存mvg查询的数据
                                var cacheNotFindMap = new Map();
                                pickConfig.push(cacheNotFindMap); // 记录mvg未查到键和标记
                                mvgValueMap.set(temConfig[i].field, mvgConfig);
                                mvgConfig = []; // 每次set进map需要重新初始化
                            }
                        } else {
                            // 此处需要把不导入的字段delete掉，否则在更新数据的时候这些字段名有干扰
                            delete temConfig[i].field;
                        }
                    }
                    // 获取各个模块的url关键字,导入数据后根据modelUrl来判断调用哪个回调函数
                    var url = DataStore.pubdataImportconfig.inserturl;
                    var allUrl = url.split('/');
                    DataStore.modelUrl = allUrl[allUrl.length - 2];
                }
            },

            /**
             * 点击界面"导入数据"按钮调用的方法，该方法主要是初始化数据，
             */
            doImport: function () {
                // 生成导入时间
                var myDate = new Date();
                myDate.setDate(myDate.getDate());
                DataStore.tmpDataImportData = myDate.getFullYear() + '-' + linkTools.NumbertoLen2String(Number(myDate.getMonth()) + Number(1)) + '-' + linkTools.NumbertoLen2String(myDate.getDate());
                this.totalCount = this.items.length;
                this.currentCount = 0;
                this.successCount = 0;
                this.errorCount = 0;
                // 这里才调用真正导入操作的方法
                this.ImportRows(this.importCallback);
            },

            /**
             * 删除方法，界面上点击删除按钮的响应方法
             * @param n
             */
            deleteId: function (n) {
                this.items.splice(n, 1); // 删除这条记录，并在界面上消失该条记录
                this.totalCount--; // 将记录总条数减一
            },
            /**
             * 数据校验初始化
             */
            doCheck: function () {
                var self = this;
                self.errorCount = 0;
                self.successCount = 0;
                self.currentStatus = '数据校验中,请稍后...';
                setTimeout(function () {
                    self.doChecks(0);
                }, 1000);
            },
            /**
             * 数据检验处理
             */
            doChecks: function (i) {
                /**
                 * 因为页面不能一次性缓存所有数据，因此需要逐条查询，如果缓存有直接取缓存。
                 * 为了在界面显示校验的进度条，因此需要知道当前是第几条数据，所以需要考虑三种异步请求
                 * picklist逐条查询的异步请求
                 * mvg逐条查询的异步请求
                 * 检验是更新合适插入的异步请求
                 * @type {methods}
                 */
                var self = this;
                var checkRepeat = function (i) {
                    var currentItem = self.items[i];
                    var errorMsg = []; // 存放校验结果的报错信息
                    var lovText = '';// 存放校验出错的字段
                    // 先把状态设置为新增数据，如果是更新，下面的keyCheck方法自会检验和赋值为update的
                    self.items[i].row_status = 'NEW';
                    // 提示信息初始化
                    Vue.set(self.items[i], 'import_status', '');
                    Vue.set(self.items[i], 'import_message', '');
                    /** *******************进行默认值处理，处理逻辑：如果为空则赋值默认值***********************/
                    defaultValueMap.forEach(function (value, key, map) {
                        if (currentItem[key] == '' || typeof currentItem[key] === 'undefined') {
                            Vue.set(self.items[i], key, value);
                        }
                    });
                    /** ************************************覆盖值处理***********************************/
                    coverValueMap.forEach(function (value, key, map) {
                        Vue.set(self.items[i], key, value);
                    });
                    /** ************************************处理非空校验*********************************/
                    for (var j = 0; j < requirdConfig.length; j++) {
                        if (!currentItem[requirdConfig[j]]) {
                            lovText = lovText + requirdConfig[j] + ' ';
                        }
                    }
                    if (lovText != '') {
                        errorMsg.push(lovText + '为必输字段; ');
                        lovText = '';
                    }
                    /** ************************************正则校验处理***************************************/
                    redexValueMap.forEach(function (value, key, map) {
                        if (currentItem[key] != '' && typeof currentItem[key] !== 'undefined') {
                            var reg = new RegExp(value);
                            if (!reg.test(currentItem[key])) {
                                lovText = lovText + key + ' ';

                            }
                        }
                    });
                    if (lovText != '') {
                        errorMsg.push(lovText + '字段的正则表达验证不通过！ ');
                        lovText = '';
                    }
                    /** ************************************开始校验值列表***************************************/
                    lovMap.forEach(function (value, key, map) {
                        var lovName = self.items[i][key];
                        var tmpArray = linkLov.getLovArray(value);
                        var orgArray = self.items[i][key].split(',');
                        // 添加值列表用逗号隔开的情况
                        if (orgArray.length > 1) {
                            for (var k1 = 0; k1 < orgArray.length; k1++) {
                                for (var k2 = 0; k2 < tmpArray.length; k2++) {
                                    if (orgArray[k1] == tmpArray[k2].name) {
                                        if (k1 == 0) {
                                            self.items[i][key] = tmpArray[k2].val;
                                        } else {
                                            self.items[i][key] = self.items[i][key] + ',' + tmpArray[k2].val;
                                        }
                                    }
                                }
                            }
                        } else {
                            // 值列表没有用逗号隔开
                            for (var k = 0; k < tmpArray.length; k++) {
                                if (currentItem[key] == tmpArray[k].name) {
                                    self.items[i][key] = tmpArray[k].val;
                                    break;
                                }
                            }
                        }
                        if (currentItem[key] != '' && typeof currentItem[key] !== 'undefined' && lovName != self.items[i][key]) {
                        } else {
                            // 放开值列表值为空的那种情况
                            if (self.items[i][key] != '') {
                                lovText = lovText + key + ' ';
                            }
                        }
                    });
                    if (lovText != '') {
                        errorMsg.push(lovText + '字段的值列表独立源代码不合法！ ');
                        lovText = '';
                    }
                    // 判断里面有哪些异步请求，该走哪一个异步
                    self.checkGotoMethod(i, errorMsg);
                };
                checkRepeat(i);

            },
            /**
             * 判断有哪些异步请求，应该走哪一步（校验数据用）
             * @param i  第几条数据
             * @param errorMsg  报错信息
             */
            checkGotoMethod: function (i, errorMsg) {
                var self = this;
                // 没有picklist也没有mvg也没有更新判断，直接打印消息到界面上
                if (pickValueMap.size == 0 && mvgValueMap.size == 0 && keyConfig.length == 0) {
                    self.messageNote(i, errorMsg);
                } else {
                    // 有picklist的情况，先picklist异步操作
                    if (pickValueMap.size != 0) {
                        self.pickCheck(i, errorMsg);
                    }
                }
                // 无picklist，但是有mvg
                if (pickValueMap.size == 0 && mvgValueMap.size != 0) {
                    self.mvgCheck(i, errorMsg);
                }
                // 只有判断插入还是更新的操作
                if (pickValueMap.size == 0 && mvgValueMap.size == 0 && keyConfig.length != 0) {
                    self.keyCheck(i, errorMsg);
                }
            },
            /**
             * 检验picklist数据
             * @param i
             * @param errorMsg
             */
            pickCheck: function (i, errorMsg) {
                var self = this;
                self.nums = 0; // 每次进来需要初始化为0.这个字段用来标记picklist的个数
                /** ************************************pickList处理***********************************/
                pickValueMap.forEach((value, key) => {
                    var stayFields = 'id';
                    var pickRepeat = (value, key, pickIndex) => {
                        var isSuccess = false;
                        var jsonObi = JSON.parse(value[1]);
                        // 第一步：拼接filtersRaw
                        var txt1 = '[';
                        for (var n = 0; n < jsonObi.length; n++) {
                            // 拼接后台只返回的数据
                            stayFields = stayFields + ',' + jsonObi[n].searchParam;
                            // 判断传入的是固定值还是字段值,查询条件有可能根据字段也有可能根据固定值
                            // [{"searchParam":"orgName","searchValue":"store"},
                            // {"searchParam":"acctType","searchValue":"Terminal"}]
                            // 比如：acctType:'Terminal';
                            var searchValue = self.items[pickIndex][jsonObi[n].searchValue];
                            if (searchValue == '' || typeof searchValue === 'undefined') {
                                searchValue = jsonObi[n].searchValue;
                            }
                            txt1 += ',{"id":"' + jsonObi[n].searchParam + '","property":"' + jsonObi[n].searchParam + '","operator":"=","value":"' + searchValue + '"}';
                        }
                        txt1 += ']';
                        txt1 = txt1.replace('[,', '[').replace(',]', ']');
                        this.context.$http.axiosForm({
                            method: 'post',
                            url: value[0],
                            data: {
                                page: 1,
                                rows: 1,
                                pageFlag: true,
                                filtersRaw: txt1,
                                totalFlag: false,
                                oauthFlag: false,
                                stayFields: stayFields
                            }
                        }).then((response) => {
                            if (response.data.success) {
                                var pickResult = response.data.rows;
                                var cacheKey = self.items[pickIndex][key];
                                if (response.data.total != 0 && pickResult.length == 1) {
                                    // 将查询的结果存到缓存里
                                    if (!value[3].has(cacheKey)) {
                                        value[3].set(cacheKey, pickResult);
                                    }
                                    // value[2]是目标对象，将查出的结果赋值
                                    var jsonResult = JSON.parse(value[2]);
                                    for (var m = 0; m < jsonResult.length; m++) {
                                        self.items[pickIndex][jsonResult[m].searchParam] = pickResult[0][jsonResult[m].searchValue];
                                    }
                                    // 查询成功
                                    isSuccess = true;
                                } else {
                                    // 把未查到的存储起来，用于后面的数据来对比，如果后面的数据value[1]值一样就不用再查了
                                    if (!value[4].has(cacheKey)) {
                                        value[4].set(cacheKey, 'notFind');
                                    }
                                }
                            }
                            // 根据isSuccess来判断picklist是否成功
                            if (!isSuccess) {
                                errorMsg.push(key + '字段的picklist字段验证不通过!');
                            }
                            self.nums++;
                            self.pickGotoMethod(i, errorMsg);
                        }).catch(function (response) {
                        });
                    };
                    var cacheKey = self.items[i][key];
                    // 先查询缓存数据，如果缓存里面有，直接取缓存数据
                    if (value[3].has(cacheKey)) {
                        var pickResult = value[3].get(cacheKey);
                        // value[2]是目标对象，将查出的结果赋值
                        var jsonResult = JSON.parse(value[2]);
                        for (var m = 0; m < jsonResult.length; m++) {
                            self.items[i][jsonResult[m].searchParam] = pickResult[0][jsonResult[m].searchValue];
                        }
                        self.nums++;
                        self.pickGotoMethod(i, errorMsg);
                    } else if (value[4].has(cacheKey)) { // 说明该条数据之前就没查询出来，所以不用再查了
                        errorMsg.push(key + '字段的picklist字段验证不通过!');
                        self.nums++;
                        self.pickGotoMethod(i, errorMsg);
                    } else { // 如果缓存没有，需要重新查询新数据
                        pickRepeat(value, key, i);
                    }
                });
            },
            /**
             *封装校验picklist跳转到哪个方法的函数
             */
            pickGotoMethod: function (i, errorMsg) {
                var self = this;
                if (self.nums == pickValueMap.size) {
                    // 如果只有picklist的情况
                    if (mvgValueMap.size == 0 && keyConfig.length == 0) {
                        self.messageNote(i, errorMsg);
                    } else {
                        if (mvgValueMap.size != 0) {
                            self.mvgCheck(i, errorMsg);
                        }
                    }
                    // 没有mvg，但是有更新操作时
                    if (mvgValueMap.size == 0 && keyConfig.length != 0) {
                        self.keyCheck(i, errorMsg);
                    }
                }
            },
            /**
             * 检验mvg数据
             * @param i
             * @param errorMsg
             */
            mvgCheck: function (i, errorMsg) {
                var self = this;
                self.mvgNum = 0;
                /** ************************************Mvg处理***********************************/
                mvgValueMap.forEach((value, key)=> {
                    var stayFields = 'id';
                    var insertObj = {}; // 用于mvg对象
                    var mvgRepeat = (value, key, i) => {
                        var isSuccess = false;
                        var jsonObi = JSON.parse(value[2]);
                        // 第一步：拼接filtersRaw
                        var txt2 = '[';
                        for (var n = 0; n < jsonObi.length; n++) {
                            // 拼接后台只返回的数据
                            stayFields = stayFields + ',' + jsonObi[n].searchParam;
                            // 判断传入的是固定值还是字段值,查询条件有可能根据字段也有可能根据固定值
                            var searchValue = self.items[i][jsonObi[n].searchValue];
                            if (searchValue == '' || typeof searchValue === 'undefined') {
                                searchValue = jsonObi[n].searchValue;
                            }
                            txt2 += ',{"id":"' + jsonObi[n].searchParam + '","property":"' + jsonObi[n].searchParam + '","operator":"=","value":"' + searchValue + '"}';
                        }
                        txt2 += ']';
                        txt2 = txt2.replace('[,', '[').replace(',]', ']');
                        this.context.$http.axiosForm.post(`/action/${LinkVue.prefixUrl}/mvg/queryLeftListPage`,
                            {
                                page: 1,
                                rows: 1,
                                pageFlag: true,
                                oauthFlag: false,
                                oauth: 'All',
                                mvgMapperName: value[0],
                                filtersRaw: txt2,
                                stayFields: stayFields
                            }
                        ).then((res)=> {
                            var mvgResult = res.data.rows;
                            var cacheKey = self.items[i][key];
                            if (res.data.total != 0 && mvgResult.length == 1) {
                                // 将查询的结果存到缓存里
                                if (!value[3].has(cacheKey)) {
                                    value[3].set(cacheKey, mvgResult);
                                }
                                // value[2]是目标对象，将查出的结果赋值
                                var jsonResult = JSON.parse(value[1]);
                                for (var m = 0; m < jsonResult.length; m++) {
                                    self.items[i][jsonResult[m].searchParam] = mvgResult[0][jsonResult[m].searchValue];
                                }
                                // 该请求用来生成记录的rowId，然后把这个row_id赋值给mvg的mvgParentId
                              this.context.$http.axiosForm.post(`/action/${LinkVue.prefixUrl}/accnt/preDefaultValue`, {}
                                ).then( (res) => {
                                    self.items[i].id = res.data.result.id;
                                    // 给即将插入的参数赋值
                                    insertObj.defField = 'isDefault';
                                    insertObj.mvgMapperName = value[0];
                                    insertObj.mvgParentId = self.items[i].id;
                                    insertObj.mvgSubsetId = mvgResult[0].id;
                                    insertObj.queryDefaultFlag = true;
                                    if (value[6] == undefined) { // 如果为空需要先初始化，否则后面报错
                                        value[6] = [];
                                    }
                                    // 需要先把mvg的对象push的value[6]中，目的是校验数据的时候先不插入，在导入成功的时候再插入到中间表
                                    value[6].push(insertObj);
                                });
                                // 查询成功
                                isSuccess = true;
                            } else {
                                // 把未查到的存储起来，用于后面的数据来对比，如果后面的数据value[1]值一样就不用再查了
                                if (!value[4].has(cacheKey)) {
                                    value[4].set(cacheKey, 'notFind');
                                }
                            }

                            // 根据isSuccess来判断mvglist是否成功
                            if (!isSuccess) {
                                errorMsg.push(key + '字段的mvg检验不通过！');
                            }
                            self.mvgNum++;
                            self.mvgGotoMethod(i, errorMsg); // 判断该走哪一个异步
                        });
                    };

                    var cacheKey = self.items[i][key];
                    if (value[4] == undefined) {
                        value[4] = new Map();
                    }
                    // 先查询缓存数据，如果缓存里面有，直接取缓存数据
                    if (value[3] == undefined) {
                        value[3] = new Map();
                        mvgRepeat(value, key, i);
                    } else {
                        if (value[3].has(cacheKey)) {
                            var mvgResult = value[3].get(cacheKey);
                            // 获取rowId，并赋值给mvg
                          this.context.$http.axiosForm.post(`/action/${LinkVue.prefixUrl}/accnt/preDefaultValue`,
                                {}
                            ).then(function (res) {
                                self.items[i].id = res.data.result.id;
                                // 给即将插入的参数赋值
                                insertObj.defField = 'isDefault';
                                insertObj.mvgMapperName = value[0];
                                insertObj.mvgParentId = self.items[i].id;
                                insertObj.mvgSubsetId = mvgResult[0].id;
                                insertObj.queryDefaultFlag = true;
                                if (value[6] == undefined) {
                                    value[6] = [];
                                }
                                value[6].push(insertObj);
                            });
                            self.mvgNum++;
                            // 判断走哪个方法
                            self.mvgGotoMethod(i, errorMsg);

                        } else if (value[4].has(cacheKey)) { // 说明该条数据之前就没查询出来，所以不用再查了
                            // lovText = lovText + key + ' ';
                            errorMsg.push(key + '字段的mvg检验不通过！');
                            self.mvgNum++;
                            // 判断走哪个方法
                            self.mvgGotoMethod(i, errorMsg);
                        } else { // 如果缓存没有，需要重新查询新数据
                            mvgRepeat(value, key, i);
                        }
                    }
                });
            },
            /**
             * 封装判断调转到哪一个方法的函数
             */
            mvgGotoMethod: function (i, errorMsg) {
                var self = this;
                if (self.mvgNum == mvgValueMap.size) {
                    // 如果只有keyConfig的情况
                    if (keyConfig.length == 0) {
                        self.messageNote(i, errorMsg);
                    } else { // 走判断更新还是插入的方法
                        self.keyCheck(i, errorMsg);
                    }

                }
            },
            /**
             * 判断哪些数据需要插入哪些需要更新
             * @param i
             * @param errorMsg
             */
            keyCheck: function (i, errorMsg) {
                var self = this;
                var currentItem = self.items[i];
                /** ************************************判断是插入还是更新***********************************/
                    // 第一步：拼接filtersRaw
                var txt = '[';
                for (var k = 0; k < keyConfig.length; k++) {
                    txt += ',{"id":"' + keyConfig[k] + '","property":"' + keyConfig[k] + '","operator":"=","value":"' + currentItem[keyConfig[k]] + '"}';
                }
                txt += ']';
                txt = txt.replace('[,', '[').replace(',]', ']');
                // 第二步：拼接请求路径
                var myurl = DataStore.pubdataImportconfig.queryurl;
                var checkRepeat = (txt, itemIndex) => {
                  this.context.$http.axiosForm({
                        method: 'post',
                        url: myurl,
                        data: {
                            page: 1,
                            rows: 1,
                            pageFlag: true,
                            filtersRaw: txt
                        }
                    }).then(function (response) {
                        // 如果查询有值更新，没有值直接插入
                        if (response.data.total != 0 && response.data.rows.length == 1) {
                            // 这里处理个别字段更新的问题
                            var resObj = response.data.rows[0];
                            var temObj = self.items[itemIndex];
                            self.items[itemIndex] = response.data.rows[0];
                            for (var f = 0; f < temConfig.length; f++) {
                                // 如果Excel上该字段有值，就把此值赋给该值。
                                if (temConfig[f].field != '' && temObj[temConfig[f].field] != '') {
                                    self.items[itemIndex][temConfig[f].field] = temObj[temConfig[f].field];
                                }
                            }
                            // 状态赋值为UPDATE
                            self.items[itemIndex].row_status = 'UPDATE';
                        } else if (response.data.rows.length > 1) {
                            errorMsg.push('不能判断插入还是更新！根据主键查出的的记录有多条,请检查！');
                        }
                        // 打印界面显示信息
                        self.messageNote(itemIndex, errorMsg);
                    }).catch(function (response) {
                        console.info(response);
                    });
                };
                checkRepeat(txt, i);
            },
            /**
             * 界面打印消息
             * @param i
             * @param errorMsg
             */
            messageNote: function (i, errorMsg) {
                var self = this;
                // 判断是否校验成功
                if (errorMsg.length > 0) {
                    Vue.set(self.items[i], 'import_status', '校验失败');
                    Vue.set(self.items[i], 'import_message', errorMsg.toString());
                    self.errorCount++;
                } else {
                    Vue.set(self.items[i], 'import_status', '校验成功');
                    self.successCount++;
                }
                self.currentCount++;
                if (self.totalCount == self.successCount + self.errorCount) {
                    this.currentStatus = '校验完成';
                } else if (i < self.items.length + 1) {
                    self.doChecks(i + 1);
                }
            },
            /**
             * 真正意义上的导入方法，因为调用后端插入数据的接口了
             * @param callback
             * @constructor
             */
            ImportRows: function (callback) {
                this.currentStatus = '正在导入...'; // 把界面上的导入状态从“校验完成”变为“正在导入”
                var self = this;
                var num = 1; // 计数器，导入方法被迭代调用，用于标记结束迭代调用
                var dataList = self.items;
                var insertRow =  (dataList) => {
                  this.context.$http.axiosJson.post(DataStore.pubdataImportconfig.inserturl, dataList
                    ).then( (res) => {
                        if (res.data.success) { // 返回成功时
                            // 如果num小于总数组的长度，继续迭代调用导入方法
                            if (num < dataLists.length) {
                                insertRow(dataLists[num]);
                            }
                            Vue.set(self.items[self.currentCount], 'import_status', '导入成功');
                            Vue.set(self.items[self.currentCount], 'import_message', '');
                            self.successCount += dataList.length; // 导入成功条数加每次批量导入的长度
                            self.currentCount += dataList.length; // 导入当前条数加每次批量导入的长度
                            num++; // 计数器++
                            // 如果插入完成后，进行回调方法(只有在全部插入成功的时候才会调用回调方法)
                            if (self.successCount == self.items.length) {
                                // 如果有mvg，需要吧mvg的数据插入到中间表中
                                if (mvgValueMap.size != 0) {
                                    self.insetBtachMvg();
                                }
                                // 导入成功后的回调方法
                                callback(dataLists);
                            }
                        } else { // 返回失败时
                            // 即使这批数据导入失败也不能停，继续导入后面的记录，界面上能看到导入失败的提示
                            if (num < dataLists.length) {
                                insertRow(dataLists[num]);
                            }
                            Vue.set(self.items[self.currentCount], 'import_status', '导入失败');
                            Vue.set(self.items[self.currentCount], 'import_message',
                                (res.data.detailMessage == null || res.data.detailMessage === '') ? res.data.result : res.data.detailMessage);
                            self.errorCount += dataList.length; // 导入失败条数加每次批量导入的长度
                            self.currentCount += dataList.length; // 导入当前条数加每次批量导入的长度
                            num++; // 计数器++
                        }
                    }, function (res) {
                        Vue.set(self.items[self.currentCount], 'import_status', '导入失败');
                        Vue.set(self.items[self.currentCount], 'import_message',
                            (res.data.detailMessage == null || res.data.detailMessage === '') ? res.data.result : res.data.detailMessage);
                        self.errorCount += dataList.length; // 导入失败条数加每次批量导入的长度
                        self.currentCount += dataList.length; // 导入当前条数加每次批量导入的长度
                    });
                };
                // 为了提高数据的导入效率需要批量插入，所以对数组进行切割，每100条记录作为一个新数组放在总数组里面
                /** ***************************************切割数组*********************************************************/
                    // 按某一长度切割数组
                let index = 0; // 用来表示切割元素的范围start
                let resIndex = 0; // 用来递增表示输出数组的下标
                // 根据length和size算出输出数组的长度，并且创建它。
                dataLists = new Array(Math.ceil(dataList.length / 100));
                // 进行循环
                while (index < dataList.length) {
                    // 循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
                    dataLists[resIndex++] = dataList.slice(index, index += 100);
                }
                // 在批量upsert时需要去掉后台java中model没有的属性,否则会报该属性在对应的实体类中找不到
                for (var i = 0; i < dataLists.length; i++) {
                    for (var j = 0; j < dataLists[i].length; j++) {
                        delete dataLists[i][j].import_status; // 去掉import_status，否则后台会报错
                        delete dataLists[i][j].import_message; // 去掉import_message，否则后台会报错
                    }
                }
                /** ******************************************切割数组完成*******************************************************/
                // 开始导入第一个数组，也就是前100条记录，每次100条进行导入
                insertRow(dataLists[0]);
            },

            /**
             * 把mvg数据插入到中间表的方法
             */
            insetBtachMvg: function () {
                mvgValueMap.forEach((value) => {
                    var params = JSON.stringify(value[6]);
                  this.context.$http.axiosJson({
                        method: 'POST',
                        url: `/action/${LinkVue.prefixUrl}/mvg/batchInsert`,
                        headers: {'Content-Type': 'application/json'},
                        data: params
                    }).then((response) => {
                        if (response.status == 200 && response.data.success) {
                        }
                    });
                });
            },
            /**
             * 总回调方法，再数据导入成功后会调用该方法，该方法根据modelUrl来判断哪个对象，然后再调用对应的回调方法
             * @param dataLists
             */
            importCallback: function (dataLists) {
                var self = this;
                for (var i = 0; i < dataLists.length; i++) {
                    for (var j = 0; j < dataLists[i].length; j++) {
                        // 需要把import_status、import_message这两个属性销毁掉，因为后端没有这两个字段，否则批量操作后台报错
                        delete dataLists[i][j].import_status;
                        delete dataLists[i][j].import_message;
                    }
                }
                // 根据nodelUrl来确定调用那个回调方法
                if (modelUrl == 'user') { // 如果modelUrl为user则需要初始化密码
                    self.successCount = 0;
                    self.currentCount = 0;
                    // self.updatePsw(dataLists[0]);
                } else if (modelUrl == 'invtxn') { // 如果是库存对象，需要调用确认库存方法
                    self.successCount = 0;
                    self.currentCount = 0;
                    // self.goodConfirm(dataLists[0]);
                } else if (modelUrl == 'acctaddress') { // 如果是客户地址对象，需要调用设置默认地址方法
                    self.setDefaultAddr();
                } else if (modelUrl == 'billInfo') { // 如果是开票信息对象，需要调用设置默认开票信息方法
                    self.mainBillUpdate();
                } else {
                    self.currentStatus = '导入过程完毕!'; // 负责更新状态，导入过程完毕，并显示在界面上
                }
            },
            /**
             * 保存编辑
             */
            saveEdit: function () {
                this.editFlag = false;
            },
            /**
             * 设置默认地址(回调方法)
             */
            setDefaultAddr: function () {
                var self = this;
                var num = 0;
                var yesItems = [];
                for (var i = 0; i < self.items.length; i++) {
                    if (self.items[i].attr1 == '是') {
                        yesItems.push(self.items[i]);
                    }
                }
                // 进行设置默认地址操作
                var dosetDefaultAddr = (index) => {
                  this.context.$http.axiosForm.post(`/action/${LinkVue.prefixUrl}/acctaddress/setDefaultAddr`, {
                            id: yesItems[index].id,
                            acctId: yesItems[index].acctId
                        }
                    ).then(function (res) {
                        num++;
                        if (num < yesItems.length) {
                            dosetDefaultAddr(num);
                        } else if (num == yesItems.length) {
                            self.currentStatus = '导入过程完毕!';
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                };
                dosetDefaultAddr(0);
            },

            /**
             * 设置默认开票信息
             */
            mainBillUpdate: function () {
                var self = this;
                var num = 0;
                var yesItems = [];
                for (var i = 0; i < self.items.length; i++) {
                    if (self.items[i].attr1 == '是') {
                        yesItems.push(self.items[i]);
                    }
                }
                // 进行设置默认开票信息
                var domainBillUpdate = (index) => {
                  this.context.$http.axiosJson.post(`/action/${LinkVue.prefixUrl}/accnt/mainBillUpdate`, {
                            id: yesItems[index].accntId,
                            mainBillAccntId: yesItems[index].id
                        }
                    ).then(function (res) {
                        num++;
                        if (num < yesItems.length) {
                            domainBillUpdate(num);
                        } else if (num == yesItems.length) {
                            self.currentStatus = '导入过程完毕!';
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                };
                domainBillUpdate(0);
            },

            /**
             * 初始化密码方法
             * @param list
             */
            updatePsw: function (list) {
                var self = this;
                this.currentStatus = '正在客户初始化，请稍后...';
              this.context.$http.axiosJson.post(`/action/${LinkVue.prefixUrl}/user/genPswList`, list
                ).then((res) => {
                    if (self.num < dataLists.length - 1) {
                        self.num++;
                        self.updatePsw(dataLists[self.num]);
                    }
                    self.successCount += list.length;
                    self.currentCount += list.length;
                    if (self.successCount == self.items.length) {
                        self.currentStatus = '导入过程完毕!';
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            },

            /**
             * 升级组织
             * @param list
             */
            updateOrg: function (list) {
                var self = this;
                this.currentStatus = '正在升级组织，请稍后...';
              this.context.$http.axiosJson.post(`/action/${LinkVue.prefixUrl}/accnt/upgradeToOrgList`, list
                ).then((res) => {
                    if (self.num < dataLists.length - 1) {
                        self.num++;
                        self.updateOrg(dataLists[self.num]);
                    }
                    self.successCount += list.length;
                    self.currentCount += list.length;
                    if (self.successCount == self.items.length) {
                        // 客户初始化过程
                        self.successCount = 0;
                        self.currentCount = 0;
                        self.num = 0;
                        self.initializeAcct(dataLists[0]);
                    }
                }).catch(function (error) {
                    console.log(error);

                });
            },

            /**
             * 客户初始化
             * @param list
             */
            initializeAcct: function (list) {
                var self = this;
                this.currentStatus = '正在客户初始化，请稍后...';
              this.context.$http.axiosJson.post(`/action/${LinkVue.prefixUrl}/accnt/initializeAcctList`, list
                ).then(function (res) {
                    if (self.num < dataLists.length - 1) {
                        self.num++;
                        self.initializeAcct(dataLists[self.num]);
                    }
                    self.successCount += list.length;
                    self.currentCount += list.length;
                    if (self.successCount == self.items.length) {
                        self.currentStatus = '导入过程完毕!';
                    }
                }).catch(function (error) {
                    console.log(error);

                });
            },
            /**
             * 提交库存交易方法
             * @param list
             */
            goodConfirm: function (list) {
                var self = this;
                self.currentStatus = '正在提交库存校交易，请稍后...';
              this.context.$http.axiosJson.post(`/action/${LinkVue.prefixUrl}/invtxn/goodConfirmList`, list
                ).then(function (res) {
                    if (self.num < dataLists.length - 1) {
                        self.num++;
                        self.goodConfirm(dataLists[self.num]);
                    }
                    self.successCount += list.length;
                    self.currentCount += list.length;
                    if (self.successCount == self.items.length) {
                        self.currentStatus = '导入过程完毕!';
                    }
                });
            },
            /**
             *点击上一步
             */
            laststep: function () {
                // gotoContentPage(appCtx.cdnPath + '/linkcrm/public_data_management/step2.html?id=' + DataStore.currentSelectId);
                this.$nav.push('/modules/crm/public_data_management/public_data_manage/step2.vue', {id: DataStore.currentSelectId});
            },

            /**
             *点击下一步
             */
            nextstep: function () {
                // gotoContentPage(appCtx.cdnPath + '/linkcrm/public_data_management/step4.html');
                this.$nav.push('/modules/crm/public_data_management/public_data_manage/step4.vue');
            }
        }
    };
</script>

<style scoped>
    body {
        background: #ffffff;
    }

    .main .button {
        margin-top: 30px;
        vertical-align: middle;
        text-align: center;

    }

    button {
        border-radius: 0 !important;
    }

    [v-cloak] {
        display: none;
    }

    .ImportExcelTable {
        border-collapse: collapse;
        margin-top: 10px;

    }

    .ImportExcelTable th {
        min-width: 100px;
        padding: 5px;
        border-width: 1px;
        border-style: solid;
        border-color: #cccccc;
        background-color: #dedede;
        font-size: 10px;
    }

    .ImportExcelTable td {
        border-width: 1px;
        padding: 5px;
        /*
        padding-left: 2px;
        padding-right: 2px;
        padding-top: 2px;
        padding-bottom: 2px;
        */
        border-style: solid;
        border-color: #cccccc;
        background-color: #ffffff;
        font-size: 10px;
    }

    * {
        border-radius: 0;
    }

    .totalInfo {
        margin-top: 10px;
        font-size: 12px;
        color: #999999;
    }

    .el-progress-bar__inner {
        border-radius: 0;
    }

    .el-progress-bar__outer {
        margin-top: 10px;
        border-radius: 0;
    }

    .el-input__inner {
        padding: 0 5px;
    }
</style>
